import { GetterTree } from "vuex";
import * as types from "@/store/constants/types";
const Getters: GetterTree<any, any> = {
  [types.GETTER_CURRENT_INS_USER_INFO](state, getters, rootState) {
    if (rootState.currentUserId == null || rootState.userList.length === 0) {
      return null;
    } else {
      const insUserInfo = state.insUserList.find((user: any) => {
        return user.userId === rootState.currentUserId;
      });
      const findUser = rootState.userList.find((user: any) => {
        return user.userId === rootState.currentUserId;
      });
      console.log("GETTER_CURRENT_INS_USER_INFO rootState", rootState);
      console.log("GETTER_CURRENT_INS_USER_INFO:", insUserInfo, findUser);
      return {
        ...insUserInfo,
        ...findUser
      };
    }
  },
  [types.GETTER_INS_USER_INFO_BY_ID](state, getters, rootState) {
    return (payload: any) => {
      if (rootState.currentUserId == null || rootState.userList.length === 0) {
        return null;
      } else {
        const insUserInfo = state.insUserList.find((user: any) => {
          return user.userId === payload;
        });
        const findUser = rootState.userList.find((user: any) => {
          return user.userId === payload;
        });
        if (findUser === undefined || insUserInfo === undefined) {
          return null;
        }
        return {
          ...insUserInfo,
          ...findUser
        };
      }
    };
  }
};

export default Getters;
